module.exports = __webpack_public_path__ + "img/dashboardIcon1.9a306282.png";